import { WebAPILineGraphChartSlicerData } from '../../../../globals/webApiTypes/elements/WebAPICBS';

export const getDimensionLabel = ({
	multiDimension,
	selectedTopics,
	selectedCategories,
	labelAliases,
	dimensionKey,
}: {
	multiDimension: WebAPILineGraphChartSlicerData['multiDimension'];
	selectedTopics: WebAPILineGraphChartSlicerData['selectedTopics'];
	selectedCategories: WebAPILineGraphChartSlicerData['selectedCategories'];
	labelAliases: WebAPILineGraphChartSlicerData['labelAliases'];
	dimensionKey: string;
}) => {
	if (!multiDimension || multiDimension === 'DIMENSION_TOPIC') {
		const dimensionLabelAlias = labelAliases?.[`topic/${dimensionKey}`];
		const info = selectedTopics[dimensionKey];

		const dimensionLabel = dimensionLabelAlias || info.title;

		return dimensionLabel;
	}
	const dimensionLabelAlias =
		labelAliases?.[`category/${multiDimension}/${dimensionKey}`];
	const info = selectedCategories[multiDimension][dimensionKey];

	const dimensionLabel = dimensionLabelAlias || info.title;

	return dimensionLabel;
};
